import type { TRequestStatusReasonGroup, TStatusReasonSelection } from "@/types/intake";

export function isReasonGatedRequestStatusGroup(
  group: string | null | undefined,
): group is TRequestStatusReasonGroup {
  return group === "declined" || group === "waitlisted" || group === "cancelled";
}

export function statusReasonModeForGroup(group: TRequestStatusReasonGroup): "single" | "multi" {
  return group === "waitlisted" ? "multi" : "single";
}

export function hasRequiredStatusReason(selection: TStatusReasonSelection): boolean {
  return selection.group === "waitlisted"
    ? selection.reasonIds.length > 0
    : selection.reasonId.length > 0;
}

export function statusReasonSelectionToBody(
  selection: TStatusReasonSelection | undefined,
): Record<string, unknown> {
  if (!selection) return {};
  if (selection.group === "waitlisted") {
    return {
      waitlist_reason_ids: selection.reasonIds,
      waitlist_note: selection.note,
    };
  }
  if (selection.group === "cancelled") {
    return {
      cancel_reason_id: selection.reasonId,
      cancel_note: selection.note,
    };
  }
  return {
    decline_reason_id: selection.reasonId,
    decline_note: selection.note,
  };
}
